<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i>&nbsp; My Profile</h5>
      </div>
<div id="mainContent" class="container">
  <div class="pt-4 pb-4" *ngIf="user">
    <div class="col-md-12">
      <table class="table table-striped table-bordered table-sm">
        <thead class="">
          <tr>
            <th>Full Name</th>
            <th>User Name</th>
            <th>Login Access</th>
            <th>Employee Type</th>
            <th>Status</th>
            <th>Gender</th>
            <th>Official Email</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{user.firstName}} {{user.middleName}} {{user.lastName}}</td>
            <td>{{user.email}}</td>
            <td>Yes</td>
            <td>{{user.type}}</td>
            <td *ngIf="user.userOfficialDetails != null">
              <span *ngIf="user.userOfficialDetails.profileStatus==1">Active</span>
              <span *ngIf="user.userOfficialDetails.profileStatus==0">Closed</span>
            </td>
            <td  *ngIf="user.userOfficialDetails == null">
            <span>closed</span>
            </td>
            <td *ngIf="user.userOfficialDetails != null">{{user.userPersonalDetails.gender}}</td>
            <td *ngIf="user.userOfficialDetails == null"></td>
            <td>{{user.email}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  <br>
  <div class="container" id="mainContent">
  <div class="row p-2">
    <div class="col-md-12" style="text-align: center;">
      <span class="bg-theme-title">My Official Details</span>
    </div>
  </div>
  <div class="p-2" *ngIf="user">
    <div class="col-md-6 offset-md-3">
      <table class="table table-striped table-bordered table-sm">
        <tbody>
          <tr>
            <th>Designation:</th>
            <td>{{user.designation==null?null:user.designation.name}}</td>
          </tr>
          <tr>
            <th>Role:</th>
            <td>
             <span *ngFor="let role of user.droles">{{role.name}} ,</span>
            </td>
          </tr>
          <tr>
            <th>Date Of Joining:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.joiningDate | date: 'dd-MMM-yyyy'}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Probation Period(in months):</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.probabtionPeriod}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Date Of Confirmation:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.confirmationDate}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Laptop Service Tag Number:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.laptopServiceTagNumber}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <!-- <tr>
            <th>Data Card Number:</th>
            <td>{{user.userOfficialDetails.laptopServiceTagNumber}}</td>
          </tr> -->
          <tr *ngIf="user.userOfficialDetails!=null">
            <th>Reporting Manager:</th>
            <td *ngIf="user.userOfficialDetails.reportingManager!=null">{{user.userOfficialDetails.reportingManager.firstName}} {{user.userOfficialDetails.reportingManager.middleName}} {{user.userOfficialDetails.reportingManager.lastName}}</td>
          </tr>
          <tr *ngIf="user.userOfficialDetails==null">
            <th>Reporting Manager:</th>
            <td ></td>
          </tr>
          <tr>
            <th>Repoting Partner:</th>
            <td *ngIf="user.userOfficialDetails!=null">
              <tr *ngFor="let partner of user.userOfficialDetails.reportingPartners">
              <td style="border:none;">{{partner.reportingPartner.firstName}} {{partner.reportingPartner.middleName}} {{partner.reportingPartner.lastName}} </td>
              </tr>
            </td>
            <td *ngIf="user.userOfficialDetails==null"></td>
			      </tr>
          <tr>
            <th>Membership Number:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.membershipNumber}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Background Verification Completed:</th>
            <td *ngIf="user.userOfficialDetails!=null">
              <span *ngIf="user.userOfficialDetails.verified;else elseBlock">Yes</span>
              <ng-template #elseBlock>No</ng-template>
            </td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Bank Account Name & Branch:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.bankAcountName}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Bank Account Number:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.bankAccountNumber}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Other Official Details:</th>
            <td></td>
          </tr>
          <tr>
            <th>Leave Balance:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.pendingLeaves}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
          <tr>
            <th>Branch Name:</th>
            <td *ngIf="user.userOfficialDetails!=null">{{user.userOfficialDetails.branch.name}}</td>
            <td *ngIf="user.userOfficialDetails==null"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
